import { Directive, ElementRef, inject, Input, OnChanges, SimpleChanges } from '@angular/core';

@Directive({
  selector: '[libButtonLoader]',
  standalone: true,
})
export class ButtonLoaderDirective implements OnChanges {

  @Input() libButtonLoader = false;

  private nativeElement: HTMLElement;
  private loader: HTMLElement;
  private eRef = inject(ElementRef<HTMLElement>);
  constructor(
  ) {
    this.nativeElement = this.eRef.nativeElement;
    this.loader = document.createElement('i');
    this.loader.classList.add('loading');
    this.loader.classList.add('end-0');
    this.loader.classList.add('me-2');

    if (this.nativeElement.classList.contains("loading-dark"))
      this.loader.classList.add('loading-dark');

    this.nativeElement.append(this.loader);
  }


  ngOnChanges(changes: SimpleChanges): void {
    if (this.libButtonLoader) {
      this.nativeElement.append(this.loader);
    } else {
      this.loader.remove();
    }
  }
}
